import React, { Component } from 'react';

import './splash-screen.css';
import logo from '../../images/e28d8023-da50-49e3-8155-f1c44b436efe.png';

function splashScreen(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);


      this.state = {
        loading: false,//**** debug ****/
        //loading: true,
      };

    }


    async componentDidMount() {
      try {
        setTimeout(() => {
          this.setState({
            loading: false,
          });
        }, 2000)//1000
      } catch (err) {
        this.setState({
          loading: false,
        });
      }
    }


    render() {
      if (this.state.loading) {
        return (
          <div className='splash-screen fade-in'>
            <img src={logo} className="App-logo" alt="" />
          </div>
        )
      } else {
        return <WrappedComponent {...this.props} />;
      }
    }
  };
}

export default splashScreen;
